/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { Link } from 'react-router-dom';
import { object } from 'prop-types';
import Media from 'react-media';

const styles = (theme) => ({
    main: {
        width: '100%',
        maxWidth: '1400px',
        margin: '0 auto 20px auto',
        height: '32px',
        display: 'flex',
        boxSizing: 'border-box',
        [theme?.breakpoints?.up(1400)]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
    a: {
        textDecoration: 'none',
        flex: '1 1 auto',
        height: '100%',
        boxSizing: 'border-box',
        fontSize: '16px',
        lineHeight: '32px',
        fontWeight: 'bold',
        textAlign: 'center',
        backgroundColor: theme?.palette?.colorPrimary,
        color: theme?.palette?.colorPrimaryContrast,
        transition: 'background-color 0.23s ease-out',
        border: `1px solid ${theme?.palette?.colorPrimary}`,
        marginRight: 2,
        '&:hover, &:focus': {
            backgroundColor: theme?.palette?.colorPrimaryContrast,
            color: theme.palette.colorPrimary,
            border: `1px solid ${theme?.palette?.colorPrimary}`,
        },
    },
});

const GraphqlSubnav = ({ classes, subnavBlock }) => {
    if (subnavBlock && subnavBlock?.sub_navigation_group) {
        return (
            // display on screen >= 769 and above
            // add min func to DesktopMobile
            <Media
                query="(min-width: 769px)"
                render={() => (
                    <div className={classes.main}>
                        {
                            subnavBlock.sub_navigation_group.map((navLink) => (
                                <Link
                                    id={navLink.link?.title.split(' ').join('-').toLowerCase()}
                                    data-test="collection-sub-nav"
                                    name="collectionSubNavMenu"
                                    className={classes.a}
                                    to={navLink?.link?.href}
                                    key={navLink?.link?.title}
                                    style={{
                                        backgroundColor: `${navLink?.background_color}`,
                                        color: `${navLink?.text_color}`,
                                    }}
                                >
                                    {navLink.link?.title}
                                </Link>
                            ))
                        }
                    </div>
                )}
            />
        );
    }

    return null;
};

GraphqlSubnav.propTypes = {
    subnavBlock: object.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(GraphqlSubnav);
